import React from "react"
import { Link } from "react-router-dom"
import "./_button.scss"
import Icon from "./components/icon"

function Button({
  variant = undefined, // large-text, transparent, anchorlink, submit, button, hcpGreen
  type = undefined, // pagination, carat, carat-2, download, external, loading
  buttonUrl = "",
  targetBlank = false,
  externalLink = false,
  onClick = undefined,
  customClass = undefined,
  disabled = false,
  useInline = false,
  preventDefault = false,
  useButtonRole = true,
  children,
  ...rest
}) {
  let variantClass = ""

  switch (variant) {
    case "anchor-btn":
      variantClass = "anchorlink-normal inline"
      break
    case "max-w-none":
      variantClass = "patient-btn patient-btn--large !max-w-none"
      break
    case "large-text":
      variantClass = "patient-btn patient-btn--large"
      break
    case "normal-text":
      variantClass = "patient-btn patient-btn--normal"
      break
    case "anchorlink-normal":
      variantClass = "anchorlink-normal"
      break
    case "anchorlink":
      variantClass = "anchorlink"
      break
    case "transparent":
      variantClass = "patient-btn patient-btn--transparent"
      break
    case "submit":
      variantClass = "patient-btn patient-btn--submit"
      break
    case "hcpGreen":
      variantClass = "hcp-btn  hcp-btn--green"
      break
    case "btn":
      variantClass = "patient-btn"
      break
    default:
      variantClass = "patient-btn"
      break
  }

  function handleClick(e) {
    if (buttonUrl === "" || preventDefault || type === 'loading') {
      e.preventDefault();
    }
    if (onClick !== undefined) {
      onClick(e)
    }
  }

  if ((externalLink === true && !useInline) || variant === "submit" || variant === "button" || variant === "anchor-btn") {
    // used external links that trigger interstitial modal and form submissions
    return (
      <button
        type="button"
        disabled={disabled}
        onClick={handleClick}
        className={`${variantClass} ${customClass ?? ""}`}
        {...rest}
      >
        {children}
        <Icon type={type} />
      </button>
    )
  } else if ((externalLink === false && targetBlank === true) || useInline) {
    // trusted page or pdf with target blank
    return (
      <a
        href={buttonUrl}
        target={"_blank"}
        rel="noopener noreferrer"
        className={`${variantClass} ${customClass ?? ""}`}
        onClick={handleClick}
        {...rest}
      >
        {children}
        <Icon type={type} />
      </a>
    )
  } else {
    // internal link
    return (
      <Link
        to={buttonUrl}
        {...(useButtonRole && { role: "button" })}
        className={`${variantClass} ${customClass ?? ""}${
          type === "pagination" ? " patient-btn--pagination" : ""
        }`}
        onClick={handleClick}
        {...rest}
      >
        {children}
        <Icon type={type} />
      </Link>
    )
  }
}

export default Button
